// Property types in the words renters use in Benin. The keys match TYPE_FILTERS in
// backend/Hokue/listings/views.py.
export const TYPE_OPTIONS = [
  ['ec', 'Entrée couchée'],
  ['cs1', 'Chambre salon'],
  ['cs2', '2 chambres salon'],
  ['cs3', '3 chambres salon'],
  ['cs4', '4+ chambres salon'],
  ['villa', 'Villa / maison'],
  ['shop', 'Boutique / bureau'],
  ['plot', 'Terrain / parcelle'],
];

// À louer / À vendre. Budgets are monthly rents, or total prices for sales.
export const DEAL_OPTIONS = [['', 'Tout'], ['rent', 'À louer'], ['sale', 'À vendre']];
export const RENT_BUDGETS = [25000, 50000, 75000, 100000, 150000, 250000, 500000];
export const SALE_BUDGETS = [5000000, 10000000, 20000000, 35000000, 50000000, 100000000];

export const isSale = (l) => l.post_type === 'sale';
export const dealLabel = (l) => (isSale(l) ? 'À vendre' : 'À louer');

export const PLATFORM_LABEL = { tiktok: 'TikTok', facebook: 'Facebook' };

const UNITS = ['appartement', 'entree_personnelle', 'chambre_salon'];

export function typeLabel(l) {
  const n = l.bedrooms;
  if (UNITS.includes(l.property_type) && n) {
    const base = n === 1 ? 'Chambre salon' : `${n} chambres salon`;
    return l.property_type === 'entree_personnelle' ? `${base} · entrée perso` : base;
  }
  const ch = n ? ` · ${n} chambre${n > 1 ? 's' : ''}` : '';
  switch (l.property_type) {
    case 'entree_couchee': return 'Entrée couchée';
    case 'chambre_salon': return 'Chambre salon';
    case 'appartement': return 'Appartement';
    case 'entree_personnelle': return 'Entrée personnelle';
    case 'villa_duplex': return 'Villa / duplex' + ch;
    case 'maison': return 'Maison' + ch;
    case 'boutique_bureau': return 'Boutique / bureau';
    case 'parcelle': return 'Parcelle';
    default: return null;
  }
}

export const formatFcfa = (v) => v.toLocaleString('fr-FR') + ' F';

// 12 000 000 -> "12 M F", 1 500 000 -> "1,5 M F" (budgets of sales).
export const formatMillions = (v) => `${(v / 1e6).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} M F`;

export function priceLabel(l) {
  if (!l.price_fcfa) return null;
  if (l.price_unit === 'month') return `${formatFcfa(l.price_fcfa)} / mois`;
  if (l.price_unit === 'night') return `${formatFcfa(l.price_fcfa)} / nuit`;
  return formatFcfa(l.price_fcfa);
}

// Calendar days in the viewer's time zone: a post from 20:59 yesterday is "Hier", not "Aujourd'hui".
export function postedAgo(iso) {
  const midnight = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((midnight(new Date()) - midnight(new Date(iso))) / 86400000);
  if (days <= 0) return "Aujourd'hui";
  if (days === 1) return 'Hier';
  return `Il y a ${days} jours`;
}
